const validate = values => {
    const errors = {fecha: ''};
    if (!values.fecha) {
        errors.fecha = 'Seleccione una fecha';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/stock/producto/validate.ts